<template>
  <div class="movie-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入ID" size="small" class="param-input" v-model="params.id"></el-input>
      <el-input placeholder="请输入番号" size="small" class="param-input" v-model="params.id"></el-input>
      <el-input placeholder="请输标题" size="small" class="param-input" v-model="params.id"></el-input>
      <el-input placeholder="请输入标签" size="small" class="param-input" v-model="params.id"></el-input>
      <el-input placeholder="请输入演员" size="small" class="param-input" v-model="params.id"></el-input>
       <el-select  size="small" clearable v-model="params.enable">
          <el-option v-for="item in shelvesList" :value="item.value" :label="item.label" :key="item.value" ></el-option>
      </el-select>
       <el-select size="small" clearable v-model="params.enable">
          <el-option v-for="item in categoryList" :value="item.value" :label="item.label" :key="item.value" ></el-option>
      </el-select>
       <el-select  size="small" clearable v-model="params.enable">
          <el-option v-for="item in levelList" :value="item.value" :label="item.label" :key="item.value" ></el-option>
      </el-select>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" ></el-date-picker>
      <el-button type="primary" size="small">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableDate"  style="width: 100%" border  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="" label="影片ID" align="center" fixed></el-table-column>
      <el-table-column prop="" label="番号" align="center"></el-table-column>
      <el-table-column prop="" label="影片标题" align="center"></el-table-column>
      <el-table-column prop="" label="影片封面" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="" label="GIF预览" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="" label="影片标签" align="center"></el-table-column>
      <el-table-column prop="" label="演员" align="center"></el-table-column>
      <el-table-column prop="" label="影片发行日期" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="" label="影片时长" align="center"></el-table-column>
    <el-table-column prop="" label="大小" align="center"></el-table-column>
    <el-table-column prop="" label="频道" align="center"></el-table-column>
    <el-table-column prop="" label="评分" align="center"></el-table-column>
    <el-table-column prop="" label="指数" align="center"></el-table-column>
    <el-table-column prop="" label="播放" align="center"></el-table-column>
    <el-table-column prop="" label="有效播放率" align="center"></el-table-column>
    <el-table-column prop="" label="价值" align="center"></el-table-column>
    <el-table-column prop="" label="条件" align="center"></el-table-column>
    <el-table-column prop="" label="免费时长" align="center"></el-table-column>
    <el-table-column prop="" label="上架日期" align="center"></el-table-column>
    <el-table-column prop="" label="状态" align="center">
      <template slot-scope="scope">
        <el-switch v-model="scope.row.status"></el-switch>
      </template>
    </el-table-column>
       <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="recommended">推荐</el-button>
          <el-button type="success" size="mini" icon="el-icon-edit" @click="addAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 编辑弹窗 -->
    <film-action ref="filmPopups"></film-action>
    <!-- 推荐弹窗 -->
    <recommended-popup ref="recommendedPopup"></recommended-popup>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import FilmAction from './components/filmAction'
import RecommendedPopup from './components/recommendedPopup'
import API from '@/api'
export default {
  data() {
    return {
      loading: false,
      tableDate: [1],
      total: 0,
      time: '',
      // 上架选项
      shelvesList:[
        {
          label: '全部',
          value: 1
        },
        {
          label: '开启',
          value: 2
        },
        {
          label: '关闭',
          value: 3
        }
      ],
      // 分类选项
      categoryList:[
        {
          label: '全部',
          value: 1,
        },
        {
          label: '日本',
          value: 2,
        },
        {
          label: '欧美',
          value: 3,
        },
        {
          label: '动漫',
          value: 4,
        },
        {
          label: '金币专区',
          value: 5,
        },
        {
          label: '麻豆传媒',
          value: 6,
        },
      ],
      // vip等级选项
      levelList: [
        {
          label: '全部',
          value: 1
        },
        {
          label: 'vip',
          value: 2
        },
        {
          label: '免费',
          value: 3
        },
        {
          label: '限免',
          value: 4
        },
        {
          label: '付费',
          value: 5
        },
      ],
      imgUrl: baseConfig.imgUrl,
      params: {
        id: '',
        pageNumber: 1,
        pageSize: 10,
        turnOn :false,
        enable: ''
      }
    }
  },
  created() {
    // this.getRankList()
  },
  components: {
    FilmAction,
    RecommendedPopup
  },
  methods: {
    // 请求排行列表数据
    getRankList() {
      this.loading = true
      API.getRankList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 推荐弹窗
    recommended() {
      this.$refs.recommendedPopup.open()
    },
    // 编辑弹窗
    addAction(type,data){
      this.$refs.filmPopups.open(type,data)
    },
     // 监听编辑成功过后重新拉去数据
    handlerRankList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getRankList()
    },
    // 编辑排行弹窗
     editToday(type,row) {
      this.$refs.editToday.open(type,row)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRankList()
    },
  }
}
</script>
